// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"8c48244b","453":"d346bd73"}[chunkId] + ".chunk.js";
};